<ion-content>
  <ion-header>
    <ion-toolbar mode="ios">
      <ion-button
        (click)="close()"
        fill="clear"
        color="dark"
        class="ion-no-padding"
      >
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-img
          [src]="dataServ.rData.dark_logo"
          *ngIf="dataServ.rData?.dark_logo[0]"
        ></ion-img>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ng-container *ngIf="orders; else noOrder">
    <ion-grid class="form">
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary" class="ion-text-center">
            <h1>
              <b>{{ "My Orders" | translate }}</b>
            </h1>
          </ion-text>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="orders">
        <ion-col size="12" *ngFor="let order of orders; let i = index">
          <ion-card>
            <!-- <img src="assets/img/logo-outline.svg"> -->

            <ion-card-header>
              <ion-card-title>
                {{ order.menu_item_name | caption }} 
                <span *ngIf="order.requestlines && order.requestlines.length > 0">- {{ order.requestlines[0].name }}</span>
              </ion-card-title>
              <ion-card-subtitle color="primary">
                {{ order.order_date | date : "dd/MM/yyyy HH:mm" }}
              </ion-card-subtitle>

              <ion-text color="dark">
                {{ "Status" | translate }}:
                <b>{{ order.status | lowercase | caption | translate }}</b>
                <ng-container *ngIf="order.requestlines && (order.requestlines | totalAmount) > 0">
                  <br />
                  {{ "Total Amount" }}:
                  <b>
                    {{ order.requestlines[0]?.currency_code || '' }}{{ order.requestlines | totalAmount }}
                  </b>
                </ng-container>
              </ion-text>

              <ion-button *ngIf="order.requestlines && order.requestlines.length > 0"
                class="detail-button"
                (click)="displays[i] = !displays[i]"
                expand="block"
                fill="clear"
              >
                {{ "Details" | translate }}
              </ion-button>
            </ion-card-header>
            <ion-card-content *ngIf="displays[i]">
              <ion-list *ngIf="order.requestlines && order.requestlines.length > 0">
                <ion-item *ngFor="let line of order.requestlines">
                  <ion-label text-wrap>
                    {{ line.quantity }} x
                    <b
                      ><span [innerHtml]="line.name.slice(0, 18)"></span
                      ><span *ngIf="line.name.length > 18">...</span>
                      <span *ngIf="line.unit_of_measure"
                        >(<span [innerHtml]="line.unit_of_measure"></span
                        >)</span
                      ></b
                    >
                    <span class="ion-float-right">
                      <b>{{ line.currency_code }}{{ line.amount }}</b></span
                    >
                  </ion-label>
                </ion-item>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>

  <ng-template #noOrder>
    <ion-row class="message-row">
      <ion-col size="12">
        <ion-icon class="close-icon" color="primary" name="close-circle-outline"></ion-icon>
        <ion-text class="message">
         <b> {{ "You don't have any orders." | translate }}</b>
        </ion-text>
      </ion-col>
    </ion-row>
  </ng-template>
</ion-content>
